import type { SVGComponentProps } from 'BreetHelpers';

export const AnimatedLoaderIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='30'
		height='30'
		viewBox='0 0 40 40'
		{...rest}
	>
		<circle
			cx='20'
			cy='20'
			r='17'
			stroke='#ffffff'
			strokeWidth='4'
			fill='none'
			strokeLinecap='round'
			strokeDasharray='50 100'
		>
			<animateTransform
				attributeName='transform'
				attributeType='XML'
				type='rotate'
				from='0 20 20'
				to='360 20 20'
				dur='1s'
				repeatCount='indefinite'
			/>
		</circle>
	</svg>
);
